import {
  MarkDoneRequest,
  PetCare,
  PetCareHistory,
  PetCareRequest,
  PetCareType,
} from "@/types/petCare";
import { BaseService } from "./base.service";

export class PetCareService extends BaseService {
  constructor() {
    super("pet-care");
  }

  async getPetCare(memberId: string, type: PetCareType): Promise<PetCare> {
    return await this.get<PetCare>(`/${memberId}/${type}`);
  }

  async getPetCareById(petCareId: string) {
    return await this.get<PetCare>(`/${petCareId}`);
  }

  async createPetCare(
    memberId: string,
    petCareRequest: PetCareRequest
  ): Promise<PetCare> {
    return await this.post<PetCare>("", { memberId, ...petCareRequest });
  }

  async updatePetCare(
    memberId: string,
    petCareRequest: PetCareRequest
  ): Promise<PetCare> {
    return await this.put<PetCare>("", { memberId, ...petCareRequest });
  }

  async getHistory(
    memberId: string,
    type: PetCareType
  ): Promise<PetCareHistory[]> {
    return await this.get<PetCareHistory[]>(`/${memberId}/${type}/history`);
  }
}

export const petCareService = new PetCareService();
